import { bidWidth } from './shared-constant';

export const getCategoryTargetItemStyles = () => ({
  customLabelEditRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 16,
    "& div[role='alert'] .error": {
      color: '#A80000',
      marginTop: 10,
      marginBottom: 10,
      fontSize: 12,
    },
  },
  editRow: {
    display: 'flex',
    gap: '10px',
  },
  bidEdit: {
    width: bidWidth,
    '& .fui-Input': {
      width: '100%',
    },
  },
});
